export const environment = {
  production: false,
  env: 'Desarrollo',
  HomeTitle:'Comeca - Development environment',
  ApiUrl: "https://gcjpiapidev.clavisco.com/",
  recatpchaSiteKey: '6Le4V6QrAAAAAClRqFhv37b_LK8ZFdM325HZPeiz',
  LogRocketId: ''
};
